module.exports = __webpack_public_path__ + "img/menu_my_icc.fddfa15f.png";